import {
  combination
} from '../../plugins/utils';

let allSku = [];

function getAllSku(Skus) {

  Skus.forEach((item) => {
    const tempAllSku = _getPotentialsku(item);
    allSku = allSku.concat(tempAllSku);
  });
  // 多维变一维 ，然后去重
  return Array.from(new Set(allSku.flat()));
}
// 通过单个sku获取所以潜在sku
function _getPotentialsku(sku) {
  const skuArray = sku.propsIds.split(';');
  // console.log('_getPotentialsku--------------', skuArray, sku);
  const potentialsku = [];
  // 通过组合算法，获取潜在sku
  for (let i = 1; i <= skuArray.length; i++) {
    potentialsku.push(combination(skuArray, i).map(items => {
      return items.join(';');
    }));
  }
  return potentialsku;
}

function seletedSku2props_ids(seletedSku) {
  const propsIds = [];
  for (const key in seletedSku) {
    const val = seletedSku[key];
    if (val) propsIds.push(key + ':' + seletedSku[key].valueId);
  }
  return propsIds.join(';');
}

export {
  getAllSku,
  seletedSku2props_ids
};
